import axios from 'src/admin-axios';
import Constants from 'src/constants';

export const payments = {
    namespaced: true,
    state: {
        productsList: [],
        priceDetails: [],
        taxRates: [],
        organizationsTransactionList: [],
        WebhooksList: [],
        aiCredits: {},
        aiCreditPurchaseRequestsList: {},
    },
    getters: {
        getProductsList (state) {
            return state.productsList;
        },
        getPriceDetails (state) {
            return state.priceDetails;
        },
        getTaxRates (state) {
            return state.taxRates;
        },
        getOrganizationsTransactionList (state) {
            return state.organizationsTransactionList;
        },
        getWebhooksList (state) {
            return state.WebhooksList;
        },
        getAiCredits (state) {
            return state.aiCredits;
        },
        getAiCreditPurchaseRequestsList (state) {
            return state.aiCreditPurchaseRequestsList;
        },
    },
    mutations: {
        setProductsList (state, data) {
            state.productsList = data;
        },
        setPriceDetails (state, data) {
            state.priceDetails = data;
        },
        setTaxRates (state, data) {
            state.taxRates = data;
        },
        setOrganizationsTransactionList (state, data) {
            state.organizationsTransactionList = data;
        },
        setWebhooksList (state, data) {
            state.WebhooksList = data;
        },
        setAiCredits (state, data) {
            state.aiCredits = data;
        },
        setAiCreditPurchaseRequestsList (state, data) {
            state.aiCreditPurchaseRequestsList = data;
        },
    },
    actions: {
        async fetchProductsList ({ dispatch, commit }) {
            const url = '/payments/products';
            try {
                const details = await axios.get(url);
                commit('setProductsList', details.data);
            } catch (exception) {
                dispatch('alert/onAlert', {
                    message: 'Something went wrong in getting Products list.',
                    type: Constants.ALERT_TYPE_ERROR,
                }, { root: true });
            }
        },
        async createNewProduct ({ dispatch }, payload) {
            const url = '/payments/products';
            try {
              await axios.post(url, payload);
            } catch (exception) {
                dispatch('alert/onAlert', {
                    message: 'Something went wrong in creating the Product.',
                    type: Constants.ALERT_TYPE_ERROR,
                }, { root: true });
                throw exception;
            }
        },
        async addPrices ({ dispatch }, payload) {
            const url = `/payments/products/${payload.productId}/prices`;
            try {
              await axios.post(url, payload.priceDetails);
            } catch (exception) {
                dispatch('alert/onAlert', {
                    message: 'Something went wrong in adding Price.',
                    type: Constants.ALERT_TYPE_ERROR,
                }, { root: true });
                throw exception;
            }
        },
        async fetchPriceDetails ({ dispatch, commit }, payload) {
            const url = `/payments/products/${payload.productId}/prices`;
            try {
                const details = await axios.get(url);
                commit('setPriceDetails', details.data);
            } catch (exception) {
                dispatch('alert/onAlert', {
                    message: 'Something went wrong in getting Price details.',
                    type: Constants.ALERT_TYPE_ERROR,
                }, { root: true });
            }
        },
        async createTaxRate ({ dispatch }, payload) {
             const url = '/payments/taxes';
            try {
              await axios.post(url, payload);
            } catch (exception) {
                dispatch('alert/onAlert', {
                    message: 'Something went wrong in creating tax rate.',
                    type: Constants.ALERT_TYPE_ERROR,
                }, { root: true });
                throw exception;
            }
        },
        async fetchTaxRates ({ dispatch, commit }) {
            const url = '/payments/taxes';
            try {
                const details = await axios.get(url);
                commit('setTaxRates', details.data);
            } catch (exception) {
                dispatch('alert/onAlert', {
                    message: 'Something went wrong in getting Tax Rates list.',
                    type: Constants.ALERT_TYPE_ERROR,
                }, { root: true });
            }
        },
        async fetchOrganizationsTransactionList  ({ dispatch, commit }) {
            const url = '/payments/payment-history';
            try {
                const details = await axios.get(url);
                commit('setOrganizationsTransactionList', details.data);
            } catch (exception) {
                dispatch('alert/onAlert', {
                    message: 'Something went wrong in fetching organizations transaction history.',
                    type: Constants.ALERT_TYPE_ERROR,
                }, { root: true });
            }
        },
        async fetchOrganizationTransactionList ({ dispatch, commit }, { params }) {
            const url = '/payments/payment-history';
            try {
                const response = await axios.get(url, { params: params });
                commit('setOrganizationsTransactionList', response.data);
            } catch (exception) {
                dispatch('alert/onAlert', {
                    message: 'Something went wrong in fetching the transaction history of selected organization.',
                    type: Constants.ALERT_TYPE_ERROR,
                }, { root: true });
            }
        },
        async fetchWebhooksList ({ dispatch, commit }) {
            const url = '/payments/webhooks';
            try {
                const details = await axios.get(url);
                commit('setWebhooksList', details.data);
            } catch (exception) {
                dispatch('alert/onAlert', {
                    message: 'Something went wrong in getting Webhooks list.',
                    type: Constants.ALERT_TYPE_ERROR,
                }, { root: true });
            }
        },
        async  updatePriceStatus ({ dispatch }, payload) {
            const url = `/payments/products/price/${payload.priceId}`;
            try {
                await axios.put(url, payload.priceStatus);
            } catch (exception) {
                dispatch('alert/onAlert', {
                    message: 'Something went wrong in updating price status.',
                    type: Constants.ALERT_TYPE_ERROR,
                }, { root: true });
                throw exception;
            }
        },
        async fetchAiCredits ({ dispatch, commit }, payload) {
            const url = `organizations/${payload.organizationId}/ai-credits`;
            try {
                const details = await axios.get(url);
                commit('setAiCredits', details.data);
            } catch (exception) {
                dispatch('alert/onAlert', {
                    message: 'Something went wrong in getting AI credits details.',
                    type: Constants.ALERT_TYPE_ERROR,
                }, { root: true });
                throw exception;
            }
        },
        async fetchAiCreditPurchaseRequestsList ({ dispatch, commit }, payload) {
            const url = 'ai-credit-purchase-requests';
            try {
                const response = await axios.get(url, { params: payload && payload.params });
                commit('setAiCreditPurchaseRequestsList', response.data);
            } catch (exception) {
                dispatch('alert/onAlert', {
                    message: 'Something went wrong in getting the AI credit purchase requests list.',
                    type: Constants.ALERT_TYPE_ERROR,
                }, { root: true });
            }
        },
        async reviewAiCreditPurchaseRequest ({ dispatch }, payload) {
            const url = `ai-credit-purchase-requests/${payload.requestId}`;
            try {
                await axios.put(url, { status: payload.status });
            } catch (exception) {
                dispatch('alert/onAlert', {
                    message: 'Something went wrong in updating the purchase request.',
                    type: Constants.ALERT_TYPE_ERROR,
                }, { root: true });
                throw exception;
            }
        },
        async updateAiCredits ({ dispatch }, payload) {
            const url = `organizations/${payload.organizationId}/ai-credits`;
            try {
                await axios.put(url, payload.aiCreditsDetails);
            } catch (exception) {
                dispatch('alert/onAlert', {
                    message: 'Something went wrong in updating AI credits.',
                    type: Constants.ALERT_TYPE_ERROR,
                }, { root: true });
                throw exception;
            }
        },
    },
};
